import { TravelFeedSlotDirective } from '../travel-feed-ticket/travel-feed-slot.directive';
import { TravelFeedTicketComponent } from '../travel-feed-ticket/travel-feed-ticket.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AnalyticService } from '../../services/analytic.service';
import { WishlistService } from '../../services/wishlist.service';
import { GuideBannersComponent } from '../guide-banners/guide-banners.component';
import { IncorrectFiltersComponent } from '../filters/incorrect/incorrect-filters.component';
import { RecommendationToursComponent } from '../recommendation-tours/recommendation-tours.component';
import { TourCallbackComponent } from './tour-callback/tour-callback.component';
import { TourCashbackComponent } from './tour-cashback/tour-cashback.component';
import { TourPersonalManagerComponent } from './tour-personal-manager/tour-personal-manager.component';
import { TourComponent } from './tour/tour.component';
import { TourFilterHelpComponent } from './tour-filter-help/tour-filter-help.component';
import { TourIncludeComponent } from './tour-include/tour-include.component';
import { TourOnlineBookingComponent } from './tour-online-booking/tour-online-booking.component';
import { ToursSkeletonComponent } from './tours-skeleton/tours-skeleton.component';
import { WindowRefService } from '../../services/window-ref.service';
import { PaginationComponent } from '../pagination/pagination.component';
import {BehaviorSubject, forkJoin, merge, of, Subject, Subscription, timer} from 'rxjs';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {EventBusService} from 'src/app/services/event-bus.service';
import {
  BrandList,
  HTTPSearchResult,
  HTTPSearchResultFiltersResponse,
  HTTPSearchResultRecommendedTour,
  HTTPSearchResultTour,
  WishlistHotelsResponse
} from 'src/app/models';
import {LocalScrollToService} from '../../services/local-scroll-to-service';
import {OnDestroy$} from '@pdtec/ngx-observable-lifecycle';
import {TimeoutPopupService} from 'src/app/services/timeout-popup.service';
import {ToursStateService} from 'src/app/services/tours-state.service';
import {environment} from "../../../environments/environment";
import {filter, map, switchMap, takeUntil, tap} from 'rxjs/operators';
import {HttpSearchService} from "../../services/search/search-requests.service";
import {SearchService} from "../../services/search/search.service";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";
import {SearchProgressService} from "../../services/search-progress.service";

@Component({
  selector: 'app-tours',
  templateUrl: environment.mobile ? './tours.component.mobile.html' : './tours.component.html',
  styleUrls: environment.mobile ? ['./tours.component.mobile.scss'] : ['./tours.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TravelFeedTicketComponent,
    TravelFeedSlotDirective,
    GuideBannersComponent,
    IncorrectFiltersComponent,
    TourCallbackComponent,
    TourComponent,
    TourFilterHelpComponent,
    TourIncludeComponent,
    TourOnlineBookingComponent,
    RecommendationToursComponent,
    TourCashbackComponent,
    TourPersonalManagerComponent,
    ToursSkeletonComponent,
    PaginationComponent,
  ]
})
export class ToursComponent extends OnDestroy$ implements OnInit, OnDestroy {
  @ViewChild('loadMoreSentinel') set loadMoreSentinelRef(ref: ElementRef<HTMLElement> | undefined) {
    if (!ref) {
      return;
    }

    this.observeLoadMoreSentinel(ref.nativeElement);
  }

  toursNotFound$ = this.searchService.toursNotFound$;
  isShowTourLoader = true;
  isShowNotFound = false;
  isShowIncorrectFilters = false;
  isRenderShortTour = false;
  isRenderHotelPriceCalendar = false;
  isRenderFilterHelp = true;
  isRenderCallbackHelp = true;
  isRenderTourIncludesHelp = true;
  isRenderOnlineBooking = true;
  isShowManagerAndCashbackBanners = false;
  isRenderPersonalManager = true;
  isRenderTourCashback = true;
  isFindTours = false;
  isOnlyHotelsSearch = false;
  isToursPaginationEnabled = false;
  firstHotelIds = [];
  wishlistHotels: number[] = [];
  recommendations: HTTPSearchResultRecommendedTour[];
  hasApplyFilters = true;

  tours: HTTPSearchResultTour[] = [];
  totalToursCount = 0;
  pageCount = 0;
  loadedPage = 1;
  isLoadingMoreTours = false;
  isSearchDoneForLoadMore = false;
  private firstPageToursCount = 0;

  private timeoutPopupSubscription: Subscription;
  private mainSearchSubscription: Subscription;
  private stateChangedSubscription: Subscription;
  private postfilterSubscription: Subscription;
  private postfilterSearchSubscription: Subscription;
  private completeSearch$: Subject<void>;
  private completePostfilterSearch$: Subject<void>;
  private searchId: string;
  private showMap = false;

  private readonly loaderTimeout = 500;
  private readonly loadMoreTriggerOffsetPx = 560;

  private observedHotels = new Set<number>();
  private pendingTourTimers = new Map<number, number>();
  private tourViewObserver: IntersectionObserver | null = null;
  private loadMoreObserver: IntersectionObserver | null = null;
  private observedTours = new Map();
  brandId: number = 0;

  constructor(
      @Inject(HOTEL_TOURS_PAGE_CONFIG) private appConfig: HotelToursPageConfig,
      @Inject(DOCUMENT) private document: Document,
      private searchService: SearchService,
      private httpSearchService: HttpSearchService,
      private eventBus: EventBusService,
      private state: ToursStateService,
      private timeoutPopupService: TimeoutPopupService,
      private scrollToService: LocalScrollToService,
      private cdRef: ChangeDetectorRef,
      private windowService: WindowRefService,
      private analyticService: AnalyticService,
      private wishlistService: WishlistService,
      private searchProgressService: SearchProgressService,
  ) {
    super();

    this.isRenderFilterHelp = this.appConfig.isRenderFilterHelp;
    this.isRenderCallbackHelp = this.appConfig.isRenderCallbackHelp;
    this.isRenderTourIncludesHelp = this.appConfig.isRenderTourIncludesHelp;
    this.isRenderOnlineBooking = this.appConfig.isRenderOnlineBooking;
    this.isShowManagerAndCashbackBanners = this.appConfig.isShowManagerAndCashbackBanners;
    this.isRenderPersonalManager = this.appConfig.isRenderPersonalManager;
    this.isRenderTourCashback = this.appConfig.isRenderTourCashback;
    this.isRenderHotelPriceCalendar = this.appConfig.isRenderHotelPriceCalendar;
    this.isOnlyHotelsSearch = Boolean(this.appConfig.searchFormValues?.hotelsSearch);
    this.isToursPaginationEnabled = this.appConfig.isToursPaginationEnabled !== false;
    this.brandId = this.appConfig.brandId;
  }

  ngOnInit() {
    this.eventBus.toggleMap$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(showMap => this.showMap = showMap);

    this.searchService.newSearchStarted$
        .pipe(
            filter(searchId => !!searchId), takeUntil(this.ngOnDestroy$)
        )
        .subscribe(searchId => {
          this.updateSearchTourViewUrlParams();
          this.isOnlyHotelsSearch = Boolean(this.searchService.getLastSearchParams()?.onlyHotels);
          this.state.setPage(1);
          this.observedTours.clear();
          this.mainSearchSubscription?.unsubscribe();
          this.stateChangedSubscription?.unsubscribe();
          this.timeoutPopupSubscription?.unsubscribe();
          this.postfilterSubscription?.unsubscribe();
          this.postfilterSearchSubscription?.unsubscribe();
          this.completeSearch$?.next();
          this.completeSearch$?.complete();

          this.searchId = searchId;
          this.tours = [];
          this.resetLoadMoreState();
          this.isShowNotFound = false;
          this.isShowIncorrectFilters = false;
          this.isFindTours = false;
          this.searchService.updatePageCount(0);
          this.cdRef.detectChanges();

          this.completeSearch$ = new Subject<void>();
          this.completePostfilterSearch$ = new Subject<void>();

          const timerSrc = new BehaviorSubject<number>(0);
          let interval = 1000;

          let firstToursFound = false;
          let filtersRequestInProgress = false;
          let filtersLoaded = false;
          let searchResultSuccessSent = false;
          let emptySearchResultSent = false;
          const hasFiltersPayload = (filters: HTTPSearchResultFiltersResponse): boolean =>
              !!filters?.filters?.length;
          const updateFiltersOnce = () => {
            if (filtersLoaded || filtersRequestInProgress) {
              return;
            }

            filtersRequestInProgress = true;
            this.httpSearchService.getFilters(this.searchId, this.state.getState()).subscribe(filters => {
              this.searchService.updateFilters(filters);
              filtersLoaded = hasFiltersPayload(filters);
              filtersRequestInProgress = false;
            }, () => {
              filtersRequestInProgress = false;
            });
          };

          const analyticsContext = this.searchService.getAnalyticsContext();
          let filtersChangedSinceStart = false;
          let pollingPhase: 'initial' | 'filters' = 'initial';
          let refreshPhase: 'filters' | 'listing' = 'listing';
          this.mainSearchSubscription = timerSrc.asObservable()
              .pipe(
                  takeUntil(this.completeSearch$),
                  switchMap((time: number) => timer(time)),
                  switchMap(() => {
                      const responsePhase: 'initial' | 'filters' = filtersChangedSinceStart ? 'filters' : 'initial';
                      pollingPhase = responsePhase;
                      return forkJoin(
                          {
                            toursResponse: this.httpSearchService.getTours(this.searchId, this.state.getState()),
                            mapToursResponse: this.showMap
                                ? this.httpSearchService.getMapTours(this.searchId, this.state.getState())
                                : of([]),
                          })
                          .pipe(map(response => ({...response, responsePhase})), takeUntil(this.completeSearch$));
                  }),
              )
              .subscribe({
                next: ({toursResponse, mapToursResponse, responsePhase}) => {
                if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                const searchError = toursResponse?.error;
                if (searchError) {
                  this.handleSearchFailure(searchError, analyticsContext, responsePhase);
                  return;
                }

                const toursCount = toursResponse?.total || 0;
                this.isShowNotFound = false;
                this.searchService.updatePageCount(toursResponse.pages);
                this.updateLoadMoreState(toursResponse);
                this.searchService.updateToursCount(toursCount);
                this.searchService.onNewChunk(
                    this.searchId,
                    toursResponse.tours.length,
                    toursResponse.searchIsDone
                );

                if (!this.isFindTours && toursResponse.tours.length > 0) {
                  this.isFindTours = true;
                  interval = 5000;

                  this.getWishlistHotelsByCountryId();
                }

                if (toursCount === 0) {
                  this.isShowNotFound = false;
                }

                if (this.showMap) {
                  this.searchService.updateMapTours(mapToursResponse);
                }

                if (toursResponse.searchIsDone === true) {
                  this.isSearchDoneForLoadMore = true;
                  this.searchService.searchIsDone(this.searchId);
                  updateFiltersOnce();
                  if (firstToursFound === false) {
                    firstToursFound = true;
                    this.searchService.firstToursFound();
                  }

                  if (!searchResultSuccessSent && toursResponse.tours.length > 0) {
                    searchResultSuccessSent = true;
                    this.searchService.trackSearchResult('search_result_success', analyticsContext, responsePhase);
                  }

                  if (toursResponse.tours.length === 0) {
                    this.updateEmptyToursState(toursResponse);
                    if (!emptySearchResultSent) {
                      emptySearchResultSent = true;
                      this.searchService.trackSearchResult('search_result_empty', analyticsContext, responsePhase);
                    }
                  }
                  this.findHotelRecommendations(this.searchId);
                  this.completeSearch$.next();
                  this.completeSearch$.complete();
                } else {
                  if (toursResponse.tours.length > 0) {
                    if (!this.timeoutPopupSubscription) {
                      this.timeoutPopupSubscription = timer(60 * 60 * 1000).subscribe(() => {
                        this.timeoutPopupService.open();
                      });
                    }

                    if (firstToursFound === false) {
                      firstToursFound = true;
                      this.searchService.firstToursFound();
                      if (this.appConfig.isNeedScrollToTableTopOnFirstSearch) {
                        this.scrollToService.scrollToTableTop();
                      }
                      updateFiltersOnce();
                      this.initOnboarding();
                      this.findHotelRecommendations(this.searchId);
                    }
                  }
                  timerSrc.next(interval);
                }

                if (firstToursFound || toursResponse.searchIsDone === true) {
                  this.eventBus.hideToursLoader();
                }

                this.tours = toursResponse.tours;
                this.cdRef.detectChanges();
              },
                error: (error) => {
                  if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                  const message = this.searchErrorMessage(error);
                  this.handleSearchFailure(message, analyticsContext, pollingPhase);
                }
              });

          let stateChangedTimer = 0;
          this.stateChangedSubscription =
              merge(
                  this.searchService.pageChanged$.pipe(map(() => { refreshPhase = 'listing'; return false; })),
                  this.searchService.sortChanged$.pipe(map(() => { refreshPhase = 'listing'; return true; })),
                  this.searchService.filtersApplyed$.pipe(map(() => { refreshPhase = 'filters'; filtersChangedSinceStart = true; return true; })),
                  this.searchService.filtersReset$.pipe(map(() => { refreshPhase = 'filters'; filtersChangedSinceStart = true; return true; })),
              ).pipe(
                  tap((shouldResetPage) => {
                    if (shouldResetPage) {
                      this.state.setPage(1);
                    }
                  }),
                  tap(() => this.beginToursRefresh()),
                  tap(() => this.scrollToService.scrollToTableTop()),
                  tap(() => this.searchService.notFoundTours(false)),
                  tap(() => searchResultSuccessSent = false),
                  tap(() => emptySearchResultSent = false),
                  tap(() => stateChangedTimer = new Date().getTime()),
                  switchMap(() =>
                      forkJoin({
                        toursResponse: this.httpSearchService.getTours(this.searchId, this.state.getState()),
                        mapToursResponse: this.showMap
                            ? this.httpSearchService.getMapTours(this.searchId, this.state.getState())
                            : of([]),
                        filterResponse: this.httpSearchService.getFilters(this.searchId, this.state.getState())
                      })
                  ),
              ).subscribe(({toursResponse, mapToursResponse, filterResponse}) => {
                if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                if (toursResponse.error) {
                  this.handleSearchFailure(toursResponse.error, analyticsContext, refreshPhase);
                  return;
                }
                this.searchService.updatePageCount(toursResponse.pages);
                this.updateLoadMoreState(toursResponse);
                const timePassed = new Date().getTime() - stateChangedTimer;

                if (toursResponse.tours.length === 0 && toursResponse.searchIsDone === true && !emptySearchResultSent) {
                  emptySearchResultSent = true;
                  this.searchService.trackSearchResult('search_result_empty', analyticsContext, refreshPhase);
                }

                const updateViewFn = (response: HTTPSearchResult) => {
                  if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                  this.tours = response.tours;
                  this.loadedPage = 1;
                  this.updateEmptyToursState(response);
                  this.eventBus.hideToursLoader();
                  this.cdRef.detectChanges();
                };

                this.searchService.updateFilters(filterResponse);

                if (timePassed > this.loaderTimeout) {
                  updateViewFn(toursResponse);
                } else {
                  setTimeout(() => updateViewFn(toursResponse), this.loaderTimeout - timePassed);
                }

                if (this.showMap) {
                  this.searchService.updateMapTours(mapToursResponse);
                }

                if (toursResponse.searchIsDone === true) {
                  this.isSearchDoneForLoadMore = true;
                  this.searchService.searchIsDone(this.searchId);
                  if (toursResponse.tours.length > 0 && !searchResultSuccessSent) {
                    searchResultSuccessSent = true;
                    this.searchService.trackSearchResult('search_result_success', analyticsContext, refreshPhase);
                  }
                }

              }, error => {
                if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                this.handleSearchFailure(this.searchErrorMessage(error), analyticsContext, refreshPhase);
              });

          this.postfilterSubscription = this.searchService.postfilterSearch$
              .pipe(
                  tap(() => filtersChangedSinceStart = true),
                  tap(() => this.beginToursRefresh()),
                  tap(() => searchResultSuccessSent = false),
                  tap(() => emptySearchResultSent = false),
                  switchMap(() => this.httpSearchService.startPostFiltersSearch(this.searchId, this.state.getState())),
                  filter(v => v.timeout !== 0),
              ).subscribe((v) => {
                setTimeout(() => this.searchService.setPostfilterTimeout(v.timeout), 200);

                this.completePostfilterSearch$ = new Subject<void>();
                const postfilterTimerSrc = new BehaviorSubject<number>(0);

                this.postfilterSearchSubscription = postfilterTimerSrc.asObservable()
                    .pipe(
                        takeUntil(this.completePostfilterSearch$),
                        switchMap((time: number) => timer(time)),
                        switchMap(() =>
                            forkJoin(
                                {
                                  toursResponse: this.httpSearchService.getTours(this.searchId, this.state.getState()),
                                  filtersResponse: this.httpSearchService.getFilters(this.searchId, this.state.getState())
                                })
                                .pipe(takeUntil(this.completePostfilterSearch$))
                        )
                    )
                    .subscribe(({toursResponse, filtersResponse}) => {
                      if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                      if (toursResponse.error) {
                        this.handleSearchFailure(toursResponse.error, analyticsContext, 'filters');
                        return;
                      }
                      this.searchService.updatePageCount(toursResponse.pages);
                      this.updateLoadMoreState(toursResponse);
                      this.searchService.updateFilters(filtersResponse);
                      this.searchService.updateToursCount(filtersResponse?.total || 0);

                      if (toursResponse.searchIsDone === true) {
                        this.isSearchDoneForLoadMore = true;
                        this.searchService.searchIsDone(this.searchId);
                        this.completePostfilterSearch$.next();
                        this.completePostfilterSearch$.complete();

                        if (toursResponse.tours.length > 0 && !searchResultSuccessSent) {
                          searchResultSuccessSent = true;
                          this.searchService.trackSearchResult('search_result_success', analyticsContext, 'filters');
                        } else if (toursResponse.tours.length === 0) {
                          this.updateEmptyToursState(toursResponse);
                          if (!emptySearchResultSent) {
                            emptySearchResultSent = true;
                            this.searchService.trackSearchResult('search_result_empty', analyticsContext, 'filters');
                          }
                        }
                      } else {
                        postfilterTimerSrc.next(5000);
                      }

                      this.tours = toursResponse.tours;
                      this.loadedPage = 1;
                      this.cdRef.detectChanges();
                    }, error => {
                      if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                      this.handleSearchFailure(this.searchErrorMessage(error), analyticsContext, 'filters');
                    });
              }, error => {
                if (!this.searchService.isCurrentSearch(analyticsContext)) { return; }
                this.handleSearchFailure(this.searchErrorMessage(error), analyticsContext, 'filters');
              });
        });

    this.eventBus.toursLoaded$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((isLoaded: boolean) => {
      const isShowLoader = !isLoaded;
      if (environment.mobile && this.isRenderHotelPriceCalendar && this.isShowTourLoader !== isShowLoader) {
        // /hotels/maldives/maldivi/kurumba-villa-maafushi?tour=ST0229c4ea5828ffe94afb96d123ee4431
        // Поиск на странице отеля.
        // т.к. Loader переехал на из app.component в tours.component на странице отеля
        // снова появился bug когда поиск завершен, туры есть, но на выдаче все еще висит состояние loader
        // стоит только начать скролить страницу - срабатывает changeDetection
        // Событие toursLoaded$ при этом приходит после завершения поиска
        this.isShowTourLoader = isShowLoader;
        this.cdRef.detectChanges();
      } else {
        this.isShowTourLoader = isShowLoader;
      }
    });

    this.eventBus.mobileToursInViewport$
        .pipe(takeUntil(this.ngOnDestroy$))
        .subscribe((isViewport) => {
          if (isViewport) {
            this.initHotelViewEvents();
          }
        });

    this.searchService.filtersState$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(filters => {
      if (filters) {
        this.hasApplyFilters = true;
        this.findHotelRecommendations(this.searchId, filters);
      }
    });

    this.searchService.filtersReset$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
      if (this.hasApplyFilters) {
        this.hasApplyFilters = false;
        if (this.searchId) {
          this.findHotelRecommendations(this.searchId);
        }
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.mainSearchSubscription?.unsubscribe();
    this.stateChangedSubscription?.unsubscribe();
    this.timeoutPopupSubscription?.unsubscribe();
    this.postfilterSubscription?.unsubscribe();
    this.postfilterSearchSubscription?.unsubscribe();
    this.completeSearch$?.next();
    this.completeSearch$?.complete();
    this.completePostfilterSearch$?.next();
    this.completePostfilterSearch$?.complete();
    this.resetTourViewTracking();
    this.loadMoreObserver?.disconnect();
  }

  get toursState() {
    return this.state;
  }

  sendSearchEvent(eventName: string) {
    this.searchService.trackSearchResult(eventName);
  }

  private searchErrorMessage(error: any): string {
    return error?.error?.error || error?.error?.message || error?.error || error?.message || 'Unknown search error';
  }

  private handleSearchFailure(message: string, context = this.searchService.getAnalyticsContext(), phase: 'initial' | 'filters' | 'listing' = context.search_phase): void {
    console.error('[ToursComponent] search failed:', message);
    this.completePostfilterSearch$?.next();
    this.completePostfilterSearch$?.complete();
    this.completeSearch$?.next();
    this.completeSearch$?.complete();
    this.searchService.notFoundTours(true);
    this.searchService.searchIsDone(this.searchId);
    this.eventBus.hideToursLoader();
    this.isShowNotFound = true;
    this.isFindTours = false;
    this.tours = [];
    this.resetLoadMoreState();
    this.searchService.trackSearchResult('search_result_error', context, phase, {error_message: message});
    this.cdRef.detectChanges();
  }

  private updateEmptyToursState(response: HTTPSearchResult): void {
    if (!response.searchIsDone || response.tours.length > 0) {
      this.searchService.notFoundTours(false);
      this.isShowNotFound = false;
      this.isShowIncorrectFilters = false;
      return;
    }

    if (!environment.mobile && this.hasAppliedFilters()) {
      this.searchService.notFoundTours(false);
      this.isShowNotFound = false;
      this.isShowIncorrectFilters = true;
      this.searchProgressService.hide();
      return;
    }

    this.searchService.notFoundTours();
    this.isShowNotFound = true;
    this.isShowIncorrectFilters = false;
  }

  private hasAppliedFilters(): boolean {
    return Number(this.state.getState().applyedFiltersCount || 0) > 0;
  }

  initHotelViewEvents() {
    this.document.querySelectorAll('app-tour')
        .forEach(tour => {
          this.tourObserver(tour);
        });
  }

  private tourObserver(tour) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const tourElement = entry.target as HTMLElement;
        const hotelId = tourElement.dataset.hotelId;
        const wideSearchFormParams = this.windowService.nativeWindow.wideSearchFormParams;
        const adultCountFormParams = wideSearchFormParams.values.adult;
        const childCountFormParams = wideSearchFormParams.values.child;

        // Определяем позицию элемента в списке
        const tourElements = Array.from(document.querySelectorAll('app-tour'));
        const index = tourElements.indexOf(tourElement); // Индекс элемента в списке

        if (entry.isIntersecting) {
          if (!this.observedTours.has(hotelId)) {
            const page = this.toursState.getState().page;
            let position = index + 1;
            if (page > 1) {
              position = ((page - 1) * 20) + index + 1
            }
            const timer2 = setTimeout(() => {
              this.analyticService.trackHotelEvent({
                deviceKey: this.windowService.nativeWindow.app.v_uid,
                hotelId: Number(hotelId),
                event: 'view',
                position: position,
                order: this.state.getState().sort ? this.state.getState().sort : "default",
                crmId: this.windowService.nativeWindow.app.crm_id,
                adultCount: adultCountFormParams,
                childCount: childCountFormParams,
              });
            }, 2000); // 2 секунды

            this.observedTours.set(hotelId, timer2);
          }
        } else {
          // Отель вышел из области видимости
          if (this.observedTours.has(hotelId)) {
            clearTimeout(this.observedTours.get(hotelId));
          }
        }

      });
    }, {
      threshold: 1.0 // Элемент должен быть полностью виден
    });

    observer.observe(tour);
  }

  private updateSearchTourViewUrlParams(): void {
    const win = this.windowService.nativeWindow as any;
    const shouldSetSearchTourViewUrlParams = !environment.mobile && !!this.appConfig.hotel;

    if (!shouldSetSearchTourViewUrlParams) {
      if (win) {
        win.searchTourViewUrlParams = '';
      }
      return;
    }

    const params = this.searchService.getLastSearchParams();
    if (!params) {
      if (win) {
        win.searchTourViewUrlParams = '';
      }
      return;
    }

    const urlParams: string[] = [];
    if (params.dateFrom) urlParams.push(`dateFrom=${encodeURIComponent(params.dateFrom)}`);
    if (params.dateTo) urlParams.push(`dateTo=${encodeURIComponent(params.dateTo)}`);
    if (params.nightsFrom !== undefined && params.nightsFrom !== null) {
      urlParams.push(`nightsFrom=${encodeURIComponent(params.nightsFrom)}`);
    }
    if (params.nightsTo !== undefined && params.nightsTo !== null) {
      urlParams.push(`nightsTo=${encodeURIComponent(params.nightsTo)}`);
    }
    if (params.adults !== undefined && params.adults !== null) {
      urlParams.push(`adult=${encodeURIComponent(params.adults)}`);
    }
    if (params.childAges !== undefined) {
      const childAges = Array.isArray(params.childAges) ? params.childAges.join(',') : params.childAges;
      urlParams.push(`childAges=${encodeURIComponent(childAges || '')}`);
    }

    if (params.onlyHotels !== undefined && params.onlyHotels) {
      urlParams.push(`hotelsSearch=1`);
    }

    const operators = (params as any).operators;
    if (operators) {
      urlParams.push(`operators=${encodeURIComponent(Array.isArray(operators) ? operators.join(',') : operators)}`);
    } else {
      urlParams.push('operators=');
    }

    const airlines = (params as any).airlines;
    if (airlines) {
      urlParams.push(`airlines=${encodeURIComponent(Array.isArray(airlines) ? airlines.join(',') : airlines)}`);
    } else {
      urlParams.push('airlines=');
    }

    if (win) {
      win.searchTourViewUrlParams = urlParams.length ? `&${urlParams.join('&')}` : '';
    }
  }

  private scheduleHotelViewEvent(hotelId: number, tourElement: HTMLElement): void {
    if (this.observedHotels.has(hotelId) || this.pendingTourTimers.has(hotelId)) {
      return;
    }

    const wideSearchFormParams = this.windowService.nativeWindow.wideSearchFormParams;
    const adultCountFormParams = wideSearchFormParams?.values?.adult;
    const childCountFormParams = wideSearchFormParams?.values?.child;

    const tourElements = Array.from(this.document.querySelectorAll('app-tour'));
    const index = tourElements.indexOf(tourElement);
    const page = this.toursState.getState().page;
    let position = index + 1;

    if (page > 1) {
      position = ((page - 1) * 20) + index + 1;
    }

    const timerId = window.setTimeout(() => {
      this.pendingTourTimers.delete(hotelId);
      this.observedHotels.add(hotelId);
      this.analyticService.trackHotelEvent({
        deviceKey: this.windowService.nativeWindow.app.v_uid,
        hotelId,
        event: 'view',
        position,
        order: this.state.getState().sort ? this.state.getState().sort : 'default',
        crmId: this.windowService.nativeWindow.app.crm_id,
        adultCount: adultCountFormParams,
        childCount: childCountFormParams,
      });
    }, 2000);

    this.pendingTourTimers.set(hotelId, timerId);
  }

  private clearPendingHotelViewEvent(hotelId: number): void {
    const timerId = this.pendingTourTimers.get(hotelId);

    if (timerId === undefined) {
      return;
    }

    clearTimeout(timerId);
    this.pendingTourTimers.delete(hotelId);
  }

  private resetTourViewTracking(): void {
    this.tourViewObserver?.disconnect();
    this.tourViewObserver = null;
    this.pendingTourTimers.forEach((timerId) => clearTimeout(timerId));
    this.pendingTourTimers.clear();
    this.observedHotels.clear();
  }

  trackByFn(_, item: HTTPSearchResultTour) {
    return item.id;
  }

  loadMoreTours(): void {
    if (this.isToursPaginationEnabled || !this.canLoadMoreTours || this.isLoadingMoreTours || !this.searchId) {
      return;
    }

    const nextPage = this.loadedPage + 1;
    this.isLoadingMoreTours = true;
    this.cdRef.markForCheck();

    this.httpSearchService.getTours(this.searchId, {
      ...this.state.getState(),
      page: nextPage,
    }).subscribe({
      next: (response) => {
        this.appendLoadedTours(response, nextPage);
      },
      error: (error) => {
        console.error('[ToursComponent] load more failed:', error);
        this.isLoadingMoreTours = false;
        this.cdRef.detectChanges();
      },
    });
  }

  private appendLoadedTours(response: HTTPSearchResult, nextPage: number): void {
    this.totalToursCount = response.total ?? this.totalToursCount;
    this.pageCount = response.pages ?? this.pageCount;
    this.loadedPage = nextPage;

    if (response.tours.length > 0) {
      this.tours = [...this.tours, ...response.tours];
      this.searchService.updateToursCount(this.totalToursCount);
    }

    if (response.searchIsDone === true) {
      this.searchService.searchIsDone(this.searchId);
    }

    this.isLoadingMoreTours = false;
    this.cdRef.detectChanges();
  }

  private observeLoadMoreSentinel(element: HTMLElement): void {
    if (this.isToursPaginationEnabled) {
      return;
    }

    if (this.loadMoreObserver) {
      return;
    }

    this.loadMoreObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        this.loadMoreTours();
      }
    }, {
      // Подгружаем заранее, примерно за 2 карточки до конца списка.
      rootMargin: `${this.loadMoreTriggerOffsetPx}px 0px`,
      threshold: 0,
    });

    this.loadMoreObserver.observe(element);
  }

  get canLoadMoreTours(): boolean {
    return !this.isToursPaginationEnabled
        && this.isSearchDoneForLoadMore
        && this.nextLoadMoreCount > 0
        && this.loadedPage < this.pageCount;
  }

  get nextLoadMoreCount(): number {
    const loadedCount = this.tours?.length || 0;
    const remainingCount = Math.max(0, this.totalToursCount - loadedCount);
    const pageSize = Number(this.appConfig.pageSize) || 10;

    return Math.min(pageSize, remainingCount);
  }

  private resetLoadMoreState(): void {
    this.totalToursCount = 0;
    this.pageCount = 0;
    this.loadedPage = 1;
    this.isLoadingMoreTours = false;
    this.isSearchDoneForLoadMore = false;
    this.firstPageToursCount = 0;
  }

  private beginToursRefresh(): void {
    this.eventBus.showToursLoader();
    this.searchProgressService.start();
    this.tours = [];
    this.isShowNotFound = false;
    this.isShowIncorrectFilters = false;
    this.resetLoadMoreState();
    this.cdRef.detectChanges();
  }

  private updateLoadMoreState(response: HTTPSearchResult): void {
    this.totalToursCount = response?.total || 0;
    this.pageCount = response?.pages || 0;
    this.loadedPage = 1;
    this.isLoadingMoreTours = false;
    this.isSearchDoneForLoadMore = Boolean(response?.searchIsDone);
    this.firstPageToursCount = response?.tours?.length || 0;
    if (this.firstPageToursCount > 0 && this.appConfig.travelFeed?.eligible) {
      setTimeout(() => this.windowService.nativeWindow.htTravelFeedAnalytics?.restoreReturn(), 100);
    }
  }

  isPersonalManagerIndex(i: number): boolean {
    return i === 2 || i === 15;
  }

  isCashbackIndex(i: number): boolean {
    return i === 6 || i === 17;
  }

  get travelFeedCountryId(): number {
    return this.searchService.getLastSearchParams()?.countryId ?? this.appConfig.searchFormValues.countryId;
  }

  get showTravelFeedTicket(): boolean {
    return !!this.appConfig.travelFeed?.placement && !!this.appConfig.travelFeed?.url && !!this.travelFeedCountryId
      && this.toursState.getState().page === 1;
  }

  get feedSearchId(): string { return this.windowService.nativeWindow.__searchAnalyticsContext?.search_attempt_id || ''; }

  get travelFeedAfterSixthIndex(): number { return Math.max(0, Math.min(6, this.firstPageToursCount) - 1); }

  showTravelFeedTicketAt(index: number): boolean {
    return this.showTravelFeedTicket && index === (this.appConfig.travelFeed.placement === 'after-results' ? this.travelFeedAfterSixthIndex : 0);
  }

  travelFeedSlotAt(index: number): string {
    if (!this.appConfig.travelFeed?.eligible || this.toursState.getState().page !== 1) { return ''; }
    return [index === 0 ? 'after-first-tour' : '', index === this.travelFeedAfterSixthIndex ? 'after-results' : ''].filter(Boolean).join(',');
  }

  shouldShowInlineBlock(index: number): boolean {
    return index < this.firstPageToursCount;
  }

  getWishlistHotelsByCountryId() {
    if (!this.appConfig.isWishlist || !this.appConfig.isClientAuth) {
      return;
    }

    const countryId = this.searchService.getLastSearchParams().countryId;
    this.wishlistService.getWishlistHotelsByCountryId(countryId).subscribe({
      next: (response: WishlistHotelsResponse) => {
        this.wishlistHotels = response.hotelIds || [];
      },
      error: (error) => {
        console.error('Ошибка при проверке статуса избранного:', error);
      },
    });
  }

  initOnboarding() {
    history.scrollRestoration = 'manual';
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('_show-onboarding', {
        detail: {
          onboardingId: 'mobile_find_tours_favorites'
        }
      }));
    }, 3000);
  }

  findHotelRecommendations(searchId, filters = null) {
    if (!this.isShowRecommendations) {
      this.recommendations = [];
      this.cdRef.markForCheck();
      return;
    }

    if (filters) {
      this.httpSearchService.getHotelRecommendationsWithFilters(searchId, filters).subscribe((response) => {
        if (response.tours.length > 0) {
          this.recommendations = response.tours;
        }
      });
    } else {
      this.httpSearchService.getHotelRecommendations(searchId).subscribe((response) => {
        if (response.tours.length > 0) {
          this.recommendations = response.tours;
        }
      });
    }

    this.cdRef.markForCheck();
  }

  onInViewportChange(inViewport: any) {
    this.eventBus.mobileToursInViewport$.next(inViewport.value);
  }

  get isShowRecommendations() {
    return environment.mobile && this.brandId !== BrandList.TICKETS_KZ;
  }
}
